import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

async function initLocationMap() {
    const mapElement = document.getElementById('locationMap');
    if (!mapElement) {
        return;
    }
    // Set loader options.
    setOptions({
        key: selectrum.google_maps_api_key,
        v: 'weekly',
    });
    // Load the Maps library.
    const { Map } = (await importLibrary('maps'));
    const { AdvancedMarkerElement } = (await importLibrary('marker'));
    // Set map options.
    const mapOptions = {
        mapId: 'ccb4471540a3a256265c0de3',
        mapTypeId: 'roadmap',
        noClear: true,
        disableDefaultUI: false,
        scrollwheel: true,
        draggable: true,
        zoomControl: false,
        streetViewControl: false,
        panControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        cameraControl: false,
        center: {
            lat: 43.715494471109814,
            lng: -79.45468200276602
        },
        zoom: 13,
    };
    const mapStyles = [
        {
            "featureType": "all",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "0"
                },
                {
                    "lightness": "0"
                },
                {
                    "gamma": "1.00"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "geometry",
            "stylers": [
                {
                    "saturation": "5"
                },
                {
                    "lightness": "1"
                },
                {
                    "gamma": "1.00"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "saturation": "5"
                },
                {
                    "lightness": "0"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "gamma": 0.01
                },
                {
                    "lightness": 20
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "saturation": -31
                },
                {
                    "lightness": -33
                },
                {
                    "weight": 2
                },
                {
                    "gamma": 0.8
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#222222"
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": 30
                },
                {
                    "saturation": 30
                },
                {
                    "color": "#444444"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "saturation": 20
                },
                {
                    "color": "#444444"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "color": "#222222"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#222222"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "lightness": -20
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#222222"
                }
            ]
        }
    ];
    // Declare the map.

    const map = new Map(mapElement, mapOptions);
    //map.setOptions({styles: mapStyles});

    const markerElements = mapElement.getElementsByClassName('mapMarker');
    for (let i = 0; i < markerElements.length; i++) {
        const markerElement = markerElements[i];
        markerElement.style.display = 'block';
        const marker = new AdvancedMarkerElement({
            map,
            position: {
                lat: 43.715494471109814,
                lng: -79.45468200276602
            },
            anchorTop: 'calc(-100% - 14px)',
        });
        marker.append(markerElement);
    }
    setTimeout(function () {
        map.panBy(0, -50);
    }, 100);
}

initLocationMap().then(() => {});